"use client";

import type { FC, Ref } from "react";
import {
  AddButton,
  type AddButtonProps,
  Avatar,
  type SelectListOption,
  type UIAction,
  useActions,
  type UserRecord,
  useDebug,
} from "@huub-web/ui";

import type { TemplateIcon } from "../../types/TemplateIcon";

export interface AddButtonTemplateProps {
  value: string;
  icon?: TemplateIcon;
  options: {
    user?: UserRecord;
    title: string;
    action: UIAction;
  }[];
  type?: AddButtonProps["type"];
  size?: AddButtonProps["size"];
}

/**
 * @deprecated 💀
 */
export const AddButtonTemplate: FC<
  AddButtonTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ value, icon, options: optionsProp, type, size = "s", ref }) => {
  const { handleAction } = useActions();
  const { log } = useDebug();

  const handleSelect = (option: SelectListOption) => {
    const optionProp = optionsProp[option.value as number];

    log("purple", "AddButtonTemplate", "handleSelect", optionProp);
    if (optionProp.action) {
      handleAction(optionProp.action);
    }
  };

  const options: SelectListOption[] = optionsProp.map((option, i) => ({
    label: option.title,
    value: i,
    leading: option.user ? (
      <Avatar
        value={option.user.name}
        id={option.user.id}
        size="s"
        variant="user"
      />
    ) : undefined,
  }));

  return (
    <AddButton
      ref={ref}
      value={value}
      icon={icon}
      type={type}
      options={options}
      onSelect={handleSelect}
      size={size}
    />
  );
};
